/**
 * MBA Program pricing constants.
 *
 * Single source of truth for pricing data used across backend seeds,
 * web enrollment page, landing page, and admin.
 */

// ---------------------------------------------------------------------------
// One-time payment
// ---------------------------------------------------------------------------
export const MBA_ONE_TIME_PRICE_CENTS = 150_000; // $1,500
export const MBA_ONE_TIME_ORIGINAL_PRICE_CENTS = 250_000; // $2,500 (strike-through)
export const MBA_ONE_TIME_SAVINGS_CENTS = MBA_ONE_TIME_ORIGINAL_PRICE_CENTS - MBA_ONE_TIME_PRICE_CENTS;
export const MBA_ONE_TIME_DISCOUNT_PERCENT = Math.round(
  (MBA_ONE_TIME_SAVINGS_CENTS / MBA_ONE_TIME_ORIGINAL_PRICE_CENTS) * 100,
);

// ---------------------------------------------------------------------------
// Launch offer — the code shown by the day-three return prompt (Trigger 5).
// The discounted one-time price above already applies it at checkout.
// ---------------------------------------------------------------------------
export const MBA_LAUNCH_OFFER_CODE = 'LAUNCH40';

// ---------------------------------------------------------------------------
// Installment plan
// ---------------------------------------------------------------------------
export const MBA_INSTALLMENT_COUNT = 6;
export const MBA_INSTALLMENT_PRICE_CENTS = 25_000; // $250 per installment
export const MBA_INSTALLMENT_ORIGINAL_PRICE_PER_MONTH_CENTS = 41_667; // $416.67 (strike-through)
export const MBA_INSTALLMENT_TOTAL_CENTS = MBA_INSTALLMENT_COUNT * MBA_INSTALLMENT_PRICE_CENTS;
export const MBA_INSTALLMENT_SAVINGS_CENTS =
  MBA_INSTALLMENT_COUNT * MBA_INSTALLMENT_ORIGINAL_PRICE_PER_MONTH_CENTS - MBA_INSTALLMENT_TOTAL_CENTS;

// ---------------------------------------------------------------------------
// Currency
// ---------------------------------------------------------------------------
export const MBA_CURRENCY = 'USD';

// ---------------------------------------------------------------------------
// Money-back guarantee
// ---------------------------------------------------------------------------
export const MBA_MONEY_BACK_DAYS = 15;
export const MBA_MONEY_BACK_TITLE = `${MBA_MONEY_BACK_DAYS}-Day Money-Back Guarantee`;
export const MBA_MONEY_BACK_DESCRIPTION = `Try StartHub for ${MBA_MONEY_BACK_DAYS} days and if you are not completely satisfied, you can claim a full refund - no questions asked.`;

// ---------------------------------------------------------------------------
// MBA features list
// ---------------------------------------------------------------------------
export const MBA_FEATURES = [
  'Lifetime Access to the Platform',
  'Step-by-Step Startup Courses',
  'Live Workshops & Office Hours',
  'Templates, Tools & Resource Library',
  'Exclusive Perks & Partner Deals',
  'Access to the StartHub Community',
  'Flexible Payment Options',
  '1:1 Mentorship Access (Beta Credits)',
] as const;

// ---------------------------------------------------------------------------
// Helpers for display formatting
// ---------------------------------------------------------------------------
export function formatCentsAsUSD(cents: number): string {
  const dollars = cents / 100;
  return dollars % 1 === 0 ? `$${dollars.toLocaleString('en-US')}` : `$${dollars.toFixed(2)}`;
}
